import { logger } from './logger';

/**
 * Initialize global error handlers for catching unhandled errors
 * Call this once at app startup (in main.tsx)
 */
export const initGlobalErrorHandlers = () => {
  // Handle uncaught JavaScript errors
  window.onerror = (message, source, lineno, colno, error) => {
    logger.error('Uncaught error', error || new Error(String(message)), {
      source,
      lineno,
      colno,
      url: window.location.href,
    });
    return false; // Let the error propagate
  };

  // Handle unhandled promise rejections
  window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    logger.error('Unhandled promise rejection', event.reason, {
      url: window.location.href,
      type: 'unhandledrejection',
    });
  };

  // Flush logs before page unload
  window.addEventListener('beforeunload', () => {
    logger.flush();
  });

  // Also flush on visibility change (mobile background)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      logger.flush();
    }
  });
};
